import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'
import { Classes } from '@blueprintjs/core'
import { Formik } from 'formik'
import { hasRoleOrMore } from '../../../lib/auth/permission'
import { registerUser } from '../../../redux/user'

class UserCreatorPage extends Component {
  constructor(props) {
    super(props)
  }

  onSubmit(values) {
    if (!values.name) {
      alert('Name missing');
      return;
    }
    if (!values.mail) {
      alert('Mail missing');
      return;
    }

    return new Promise((resolve, reject) => {
      this.props.registerUser(values.name, values.mail, values.role)
        .then(() => {
          alert('User created and invitation mail with password will be send.');
          resolve();
        })
        .catch(e => {
          alert('Something went wrong. Error=' + JSON.stringify(e));
          reject();
        });
    });
  }

  render() {
    const {} = this.props

    return (
      <>
        <div className="container mt-2">
          <Formik
            initialValues={{
              name: '',
              mail: '',
              role: 'customer'
            }}
            onSubmit={(v, f) => this.onSubmit(v, f)}>
            {formik => (
              <form onSubmit={formik.handleSubmit}>
                <div className="col-sm-12 col-md-10 mx-auto">
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">Full name</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className={Classes.INPUT}
                        name="name"
                        onChange={formik.handleChange}
                        value={formik.values.name}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">E-Mail</label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className={Classes.INPUT}
                        name="mail"
                        onChange={formik.handleChange}
                        value={formik.values.mail}
                      />
                    </div>
                  </div>
                  <div className="alert alert-warning">
                    Password will be auto-generated and send to the e-Mail
                    address.
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label">Role</label>
                    <div className="col-sm-8">
                      <select
                        name="role"
                        value={formik.values.role}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}>
                        <option value="customer">Customer</option>
                        <option value="sales">Sales</option>
                        <option value="administration">Administration</option>
                        <option value="management">Management</option>
                        <option value="director">Director</option>
                      </select>
                    </div>
                  </div>
                  <div className="mt-4">
                    {hasRoleOrMore(formik.values.role, 'administration') && (
                      <p>
                        <i
                          className="material-icons mr-1"
                          style={{ verticalAlign: 'middle', color: 'green' }}>
                          check
                        </i>
                        User has to be approved by other director.
                      </p>
                    )}
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={formik.isSubmitting}>
                    Send invitation with password
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </>
    )
  }
}

const mapStateToProps = ({ articleDetails, user }) => ({})

const mapDispatchToProps = dispatch => bindActionCreators({
  registerUser
}, dispatch)

const pageRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserCreatorPage)

export default withRouter(pageRedux)
